import { render, staticRenderFns } from "./AboutLoggedOut.vue?vue&type=template&id=2a7c0ca0&scoped=true&"
import script from "./AboutLoggedOut.vue?vue&type=script&lang=ts&"
export * from "./AboutLoggedOut.vue?vue&type=script&lang=ts&"
import style0 from "./AboutLoggedOut.vue?vue&type=style&index=0&id=2a7c0ca0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7c0ca0",
  null
  
)

export default component.exports